/* ==========================================================================
   sk-mobile-search.js — Mobile search toggle (Snocks-style behavior)
   --------------------------------------------------------------------------
   Flow:
   1. Initial state: search bar visible, toggle-button hidden
   2. User clicks X (cancel-button) in search → hides search bar,
      shows toggle-button, persists to localStorage
   3. User clicks toggle-button (magnifying glass) → shows search bar,
      hides toggle-button, clears localStorage
   4. State persists across page navigation (single key: sk_search_hidden)
   ========================================================================== */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var STORAGE_KEY = 'sk_search_hidden';
  var isMobile = function () { return window.matchMedia('(max-width: 767px)').matches; };

  function getElements() {
    return {
      liveSearch: document.querySelector('.live-search'),
      searchForm: document.querySelector('.live-search-form'),
      closeBtn: document.querySelector('.live-search-takeover-cancel'),
      toggleBtn: document.querySelector('[data-mobile-search-toggle]'),
    };
  }

  function showSearch(els) {
    if (els.liveSearch) {
      els.liveSearch.style.removeProperty('display');
      els.liveSearch.removeAttribute('hidden');
      els.liveSearch.classList.remove('sk-search-hidden');
    }
    if (els.toggleBtn) {
      els.toggleBtn.setAttribute('hidden', '');
    }
    try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    // Focus input after animation
    if (els.searchForm) {
      var input = els.searchForm.querySelector('input[type="text"], input[type="search"], .form-field-input');
      if (input) setTimeout(function () { input.focus(); }, 120);
    }
  }

  function hideSearch(els) {
    if (els.liveSearch) {
      els.liveSearch.classList.add('sk-search-hidden');
    }
    if (els.toggleBtn) {
      els.toggleBtn.removeAttribute('hidden');
    }
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
  }

  function init() {
    var els = getElements();

    // Apply initial state based on localStorage (only on mobile)
    if (isMobile()) {
      var stored = null;
      try { stored = localStorage.getItem(STORAGE_KEY); } catch (_) {}
      if (stored === '1') {
        hideSearch(els);
      }
    }

    // Close-button (X) click → hide search
    if (els.closeBtn) {
      // Use capture phase to run BEFORE theme's internal handler
      els.closeBtn.addEventListener('click', function (e) {
        if (!isMobile()) return;
        e.preventDefault();
        e.stopPropagation();
        hideSearch(getElements());
      }, true);
    }

    // Toggle-button click → show search
    if (els.toggleBtn) {
      els.toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showSearch(getElements());
      });
    }

    // Resize handling: on desktop we always want search visible
    window.addEventListener('resize', function () {
      if (!isMobile()) {
        var e = getElements();
        if (e.liveSearch) {
          e.liveSearch.classList.remove('sk-search-hidden');
          e.liveSearch.style.removeProperty('display');
        }
        if (e.toggleBtn) e.toggleBtn.setAttribute('hidden', '');
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
